module.exports = __webpack_public_path__ + "static/balou-8b6b850c4596b0a9c40ef69f30a8d392.jpg";